import log from 'salvo-lite/log'

class FullPage {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._sections = this._elem.querySelectorAll('[data-section]')
        this._sectionNavItem = this._elem.querySelectorAll('[data-section-nav-item]')
        this.siteFooter = document.getElementsByClassName('site-footer')
        this._isAnimating = false
        this._currentActive = 0
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        for (let section of this._sections) {
            section.addEventListener('transitionend', e => {
                if (e.target === section) {
                    this._isAnimating = false
                }
            })
        }

        this.siteFooter[0].addEventListener('transitionend', e => {
            this._isAnimating = false
        })

        for (let navItem of this._sectionNavItem) {
            navItem.addEventListener('click', e => {
                this._isAnimating = true
                this._currentActive = Number(navItem.dataset.tabnum)
                this.footerControl()
            })
        }

        document.addEventListener('wheel', (e) => {
            let wheelStatus

            if (e.wheelDelta > 0 || e.detail < 0) {
                wheelStatus = 1
            } else {
                wheelStatus = -1
            }
            if (this._isAnimating) {
                e.preventDefault()
                return false
            } else {
                if (wheelStatus >= 0) {
                    if (this._currentActive === 0) {
                        this.footerControl()
                        return false
                    } else {
                        this.sectionUp()
                    }
                } else {
                    if (this._currentActive >= this._sections.length) {
                        this.footerControl()
                        return false
                    } else {
                        this.sectionDown()
                    }
                }
            }
        })

        log.debug(this.constructor.name, 'Initiated')
    }

    sectionDown () {
        this._currentActive += 1
        this._isAnimating = true

        if (this._currentActive >= this._sections.length) {
            this._currentActive = (this._sections.length)
        } else {
            let newSection = this._sections[this._currentActive]

            for (let section of this._sections) {
                if (section !== this._sections[this._currentActive]) {
                    section.classList.remove('active')
                }
            }
            newSection.classList.add('active')

            this.navControl()
            this.footerControl()
        }
    }

    sectionUp () {
        this._currentActive -= 1
        this._isAnimating = true

        if (this._currentActive < 0) {
            this._currentActive = 0
        }

        let newSection = this._sections[this._currentActive]

        for (let section of this._sections) {
            if (section !== this._sections[this._currentActive]) {
                section.classList.remove('active')
            }
        }
        newSection.classList.add('active')

        this.navControl()
        this.footerControl()
    }

    // As the user scrolls, also change the active navigation item
    navControl () {
        for (let navItem of this._sectionNavItem) {
            if (navItem !== this._sectionNavItem[this._currentActive]) {
                navItem.classList.remove('active')
            }
        }
        this._sectionNavItem[this._currentActive].classList.add('active')
    }

    footerControl () {
        let lastSection = (this._sections.length - 1)

        if (this._currentActive >= lastSection) {
            this.siteFooter[0].classList.add('active')
            this._isAnimating = false
        } else {
            if (this.siteFooter[0].classList.contains('active')) {
                this.siteFooter[0].classList.remove('active')
            }
        }
    }
}

export default FullPage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/FullPage.js